import loadGoogleMaps from 'load_google_maps'

const OK_STATUS = 'OK'

let geocoder = null

export default function geocode(address) {
  if (!address) return Promise.reject(new Error('no address provided'))

  if (!geocoder) {
    return loadGoogleMaps().then(gMaps => {
      geocoder = new gMaps.Geocoder()
      return geocode(address)
    })
  }

  return new Promise((resolve, reject) => {
    geocoder.geocode({ address }, (results, status) => {
      if (status !== OK_STATUS) return reject(new Error(status))

      const latLng = results[0].geometry.location
      return resolve({ lat: latLng.lat(), lng: latLng.lng() })
    })
  })
}
